import React, { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Button from "../../../../../components/buttons/buttons";
import Table from "../../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../../components/skeleton/table";
import TableFilter from "../../../../../components/tables/tableFilter";
import { getOutletFromCookies } from "../../../../../utils/Auth";
import { Pagination } from "../../../../../components/pagination/pagination";
import Merchandise from "../../../../../assets/images/icons/merchandiseEmpty.svg";
import { Beat } from "../../../../../plugins/spinners.plugin";
import {
  filterMerchandises,
  filterMerchandisesNoPage,
  searchAllMerchandises,
} from "../../../../../redux/merchandise/merchandiseActions";
import { writeFileWithXLSX } from "../../../../../components/exports/xlsx";
import { AllFiltersModal } from "../../../../../components/modals/allFiltersModal";
import FilterMerchandise from "../../../../../components/dropDown/filter/merchandiseFilter";
import merchandiseType from "../../../../../redux/merchandise/merchandiseTypes";
import ImportInventoryModal from "../../../../../components/modals/admin/importInventoryModal";

export default function MerchandiseInventory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const outlet = getOutletFromCookies();
  // let fourMonths = new Date();
  // fourMonths.setDate(fourMonths.getDate() - 120);

  const { allMerchandises, filtering, searching, downloading } = useSelector(
    (state) => state.merchandise
  );

  const [isOpen, setIsOpen] = useState(false);
  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [payLoad] = useState({
    store_id: outlet.id,
    // start_date: fourMonths,
    end_date: new Date(),
  });

  const [data, setData] = useState([]);
  let { page } = useParams();
  const [input, setInput] = useState({
    search: "",
    store_id: outlet?.id,
  });

  useEffect(() => {
    dispatch(filterMerchandises(payLoad, page));
    dispatch(filterMerchandisesNoPage(payLoad));
    // eslint-disable-next-line
  }, [page]);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];

      dataToMap?.map((merchandise) => {
        let single = {
          id: merchandise?.id,
          name: merchandise?.merchandise_name,
          price: merchandise?.merchandise_amount,
          status: (
            <span>
              {merchandise?.merchandise_operating_status === "available" ? (
                <span className="text-[#00D220]">Available</span>
              ) : (
                <span className="text-primary">Unavailable</span>
              )}
            </span>
          ),
          created_at: moment(merchandise?.created_at).format(
            "MMM DD, YYYY/ hh:mma"
          ),
          merchandise: merchandise,
        };

        outputArray.push({ single });
        return true;
      });
      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(allMerchandises?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allMerchandises]);

  function createTableDataDownload(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((merchandise) => {
        let show = {
          business_id: merchandise?.business_id || "",
          store_id: outlet?.id || "",
          merchandise_name: merchandise?.merchandise_name || "",
          url_photos: JSON.stringify(
            merchandise?.merchandise_pictures || []
          ),
          merchandise_description: merchandise?.merchandise_description || "",
          merchandise_categories: JSON.stringify(
            merchandise?.merchandise_categories || []
          ),
          merchandise_tags: JSON.stringify(merchandise?.merchandise_tags || []),
          merchandise_attributes: JSON.stringify(
            merchandise?.merchandise_attributes || []
          ),
          merchandise_amount: merchandise?.merchandise_amount || "",
          merchandise_discount: merchandise?.merchandise_discount || 0,
          merchandise_time_zone: merchandise?.merchandise_time_zone || "",
          merchandise_preparation_time:
            merchandise?.merchandise_preparation_time || "",
          merchandise_operating_status:
            merchandise?.merchandise_operating_status || "",
          merchandise_weight_in_kg: merchandise?.merchandise_weight_in_kg || "",
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  function goToSinglePage(params) {
    let merchandise_id = params?.single?.merchandise?.id;
    navigate(`/admin/${outlet.store_name}/merchandise/${merchandise_id}`, {
      state: { merchandise: params?.single?.merchandise },
    });
  }

  const handleDownload = async () => {
    const response = await dispatch(
      filterMerchandisesNoPage({
        ...payLoad,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableDataDownload(response?.data);
      writeFileWithXLSX(newData, {
        filename: `${outlet?.store_name}_Merchandise_Inventory.csv`,
        download: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allMerchandises?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: merchandiseType["SEARCH_MERCHANDISE"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchAllMerchandises(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) { }
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "Merchandise Id",
            accessor: "single.id",
          },
          {
            Header: "Name",
            accessor: "single.name",
          },
          {
            Header: "Price (NGN)",
            accessor: "single.price",
          },
          {
            Header: "Status",
            accessor: "single.status",
          },
          {
            Header: "Created At",
            accessor: "single.created_at",
          },
        ],
      },
    ],
    []
  );

  return (
    <>
      <TableFilter
        title={"Merchandise Inventory"}
        results={allMerchandises?.to}
        totalResults={allMerchandises?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        page={page}
        payLoad={payLoad}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterMerchandise
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
        searchPlaceholder={" Merchandise Name"}
      >
        <Button.Secondary
          title={"Import Inventory"}
          type="button"
          onClick={() => openModal()}
        />
        <Button.Primary
          title={downloading ? <Beat color={"#CE2600"} /> : "+ Export Inventory"}
          type="button"
          disabled={!data}
          onClick={handleDownload}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="text-center">
            {" "}
            <div className="flex justify-center my-12 ">
              <img src={Merchandise} alt="merchandise" />
            </div>
            <p className="font-bold text-xl my-3">Merchandise</p>
            <p className="text-sm text-gray-500">
              You have no Merchandise yet.
            </p>
          </div>
        )}

        {!isSearchOpen && (
          <Pagination
            data={allMerchandises}
            route={`admin/${outlet?.store_name}/merchandise/all`}
          />
        )}
      </div>
      <ImportInventoryModal
        show={isOpen}
        onClose={closeModal}
        type="merchandise"
      />
    </>
  );
}
